// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import misionn from "../Profile/profileimage/mision.webp";
// import vision from "../Profile/profileimage/mision.webp";
// import { FaEdit, FaSave } from "react-icons/fa";
// // import "./missionvissioncards.css"
// // Styles
// const containerStyle = {
//     marginTop: "10px",
//     border: "1px solid #bbb",
//     borderRadius: "10px",
// };

// const cardWrapperStyle = {
//     // display: "flex",
//     justifyContent: "center",
//     gap: "40px",
//     overflowX: "auto",
//     flexWrap: "nowrap",
//     padding: "40px",
//     borderRadius: "20px",
//     border: "none"
// };

// const baseCardStyle = {
//     backgroundColor: "#fff",
//     borderRadius: "16px",
//     border: "1px solid #b15cd6",
//     padding: "35px 30px",
//     // width: "460px",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
//     textAlign: "center",
//     transition: "all 0.3s ease-in-out",
//     cursor: "default",
//     position: "relative",
// };

// const titleBaseStyle = {
//     fontSize: "26px",
//     fontWeight: "700",
//     marginBottom: "14px",
// };


// const sectionTitleStyle = {
//     textAlign: "center",
//     fontSize: "36px",
//     fontWeight: "800",
//     color: "rgb(177 93 198)",
//     letterSpacing: "0.5px",
//     marginBottom: "-20px",
//     marginTop: "10px",
// };

// const textAreaStyle = {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "8px",
//     resize: "none",
//     fontSize: "16px",
// };

// const imageStyle = {
//     width: "80px",
//     height: "80px",
//     objectFit: "cover",
//     borderRadius: "50%",
//     marginBottom: "20px",
//     border: "2px solid #b15dc6",
// };

// // ✅ Card Component
// const Card = ({ image, title, value, onChange }) => {
//     return (
//         <div style={baseCardStyle} className="mission-vission-cards">
//             <img src={image} alt={title} style={imageStyle} />
//             <h3 style={titleBaseStyle}>{title}</h3>
//             <textarea
//                 value={value}
//                 onChange={(e) => onChange(e.target.value)}
//                 rows={5}
//                 style={textAreaStyle}
//             />
//         </div>
//     );
// };


// // Main Component
// const Cateringmissionvission = () => {
//     const [mission, setMission] = useState("");
//     const [visionDesc, setVisionDesc] = useState("");
//     const [vendorId, setVendorId] = useState(null);
//     const [aboutUsId, setAboutUsId] = useState(null);
//     const [isEditing, setIsEditing] = useState(false);

//     // Get vendorId from localStorage
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);

//     // Fetch existing data
//     useEffect(() => {
//         if (vendorId) fetchAboutUsData(vendorId);
//     }, [vendorId]);

//     const fetchAboutUsData = async (vendorId) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         try {
//             const res = await axios.get(
//                 `https://backend.maamaas.com/catering/api/aboutus/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             const data = res.data;
//             setAboutUsId(data?.aboutUsId || null);
//             setMission(data?.mission || "");
//             setVisionDesc(data?.vision || "");
//         } catch (err) {
//             console.error("Fetch Error:", err.response?.data || err.message);
//         }
//     };

//     // Send data (both POST and PUT) like About Us format
//     const sendMissionVision = async (method) => {
//         if (!vendorId) return alert("Vendor ID missing!");
//         if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Authorization token missing");

//         const aboutUsData = { mission, vision: visionDesc };
//         const formData = new FormData();
//         formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

//         const url =
//             method === "POST"
//                 ? `https://backend.maamaas.com/catering/api/vendor/aboutus/add/${vendorId}`
//                 : `https://backend.maamaas.com/catering/api/vendor/aboutus/update/${aboutUsId}`;

//         try {
//             const res = await fetch(url, {
//                 method,
//                 headers: { Authorization: `Bearer ${token}` },
//                 body: formData,
//             });

//             if (res.ok) {
//                 alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
//                 fetchAboutUsData(vendorId);
//                 setIsEditing(false);
//             } else {
//                 const err = await res.json();
//                 alert(`Failed: ${err.message || "Unknown error"}`);
//             }
//         } catch (err) {
//             console.error("Submit Error:", err);
//             alert("Something went wrong. Please try again.");
//         }
//     };

//     return (
//         <section style={containerStyle}>
//             <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
//                 <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
//                 <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
//                     <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>Add +</button>
//                     <button
//                         onClick={() => {
//                             if (isEditing) sendMissionVision("PUT");
//                             else setIsEditing(true);
//                         }}
//                         style={{ ...buttonStyle, marginLeft: "10px" }}
//                     >
//                         {isEditing ? <FaSave /> : <FaEdit />}
//                     </button>
//                 </div>
//             </div>

//             <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
//                 <Card image={misionn} title="Our Mission" value={mission} onChange={setMission} />
//                 <Card image={vision} title="Our Vision" value={visionDesc} onChange={setVisionDesc} />
//             </div>
//         </section>
//     );
// };

// const buttonStyle = {
//     backgroundColor: "#b15dc6",
//     color: "#fff",
//     fontSize: "14px",
//     padding: "10px 15px",
//     borderRadius: "6px",
//     border: "none",
//     cursor: "pointer",
// };

// export default Cateringmissionvission;




import React, { useState, useEffect } from "react";
import axios from "axios";
import misionn from "../Profile/profileimage/mision.webp";
import vision from "../Profile/profileimage/vision.jpg";
import { FaEdit, FaSave } from "react-icons/fa";
// import "./missionvissioncards.css"

// Responsive container style
const containerStyle = (isMobile, isTablet) => ({
  marginTop: isMobile ? "15px" : "20px",
  padding: isMobile ? "15px 10px" : isTablet ? "25px 15px" : "1rem 30px 30px 30px",
  borderRadius: "2vmin",
  background: "rgb(177, 93, 198)",
});

// Responsive card wrapper
const cardWrapperStyle = (isMobile, isTablet) => ({
  display: "grid",
  gridTemplateColumns: window.innerWidth < 550 ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))",
  gap: isMobile ? "20px" : isTablet ? "30px" : "40px",
  maxWidth: isMobile ? "100%" : isTablet ? "90%" : "1000px",
  margin: "0 auto",
});

// Responsive base card
const baseCardStyle = (isMobile, isTablet) => ({
  backgroundColor: "#fff",
  borderRadius: isMobile ? "12px" : "18px",
  border: "1px solid #b15cd6",
  padding: isMobile ? "20px 15px" : isTablet ? "30px 20px" : "40px 30px",
  boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
  textAlign: "center",
  position: "relative",
});

// Responsive title
const titleBaseStyle = (isMobile, isTablet) => ({
  fontSize: isMobile ? "18px" : isTablet ? "20px" : "24px",
  fontWeight: "700",
  marginBottom: isMobile ? "12px" : "18px",
  color: "#333",
});

// Responsive section title
const sectionTitleStyle = (isMobile, isTablet) => ({
  fontSize: isMobile ? "18px" : isTablet ? "28px" : "28px",
  fontWeight: "bold",
  color: "white",
  margin: "0",
  textAlign: isMobile ? "center" : "left",
  whiteSpace: "nowrap"
});

// Responsive header container
const headerContainerStyle = (isMobile, isTablet) => ({
  display: "flex",
  flexDirection: isMobile ? "row" : "row",
  justifyContent: isMobile ? "space-between" : "space-between",
  alignItems: isMobile ? "center" : "center",
  marginBottom: isMobile ? "20px" : "30px",
  gap: isMobile ? "15px" : "0",
  padding: "0px 0px",
});

// Responsive textarea
const textAreaStyle = (isEditing, isMobile, isTablet) => ({
  width: "100%",
  minHeight: isMobile ? "100px" : isTablet ? "120px" : "140px",
  padding: isMobile ? "10px" : "14px",
  borderRadius: "8px",
  resize: "vertical",
  fontSize: isMobile ? "14px" : "16px",
  lineHeight: "1.5",
  border: isEditing ? "0px solid #b15cd6" : "0px solid #ddd",
  outline: "none",
  boxSizing: "border-box",
  backgroundColor: isEditing ? "#f9f9f9" : "#f5f5f5",
});

// Responsive image
const imageStyle = (isMobile, isTablet) => ({
  width: isMobile ? "70px" : isTablet ? "80px" : "90px",
  height: isMobile ? "70px" : isTablet ? "80px" : "90px",
  objectFit: "cover",
  borderRadius: "50%",
  marginBottom: isMobile ? "15px" : "20px",
  border: "3px solid #b15dc6",
});

// Responsive button
const buttonStyle = (isMobile, isTablet) => ({
  color: "#b15dc6",
  fontSize: isMobile ? "12px" : isTablet ? "14px" : "14px",
  padding: isMobile ? "8px 10px" : isTablet ? "11px 20px" : "12px 24px",
  borderRadius: "5px",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: isMobile ? "6px" : "10px",
  fontWeight: "bold",
  boxShadow: "0 4px 8px rgba(177, 92, 198, 0.3)",
  height: isMobile ? "30px" : "35px",
  width: "80px",
  whiteSpace: "nowrap",
});

// Card Component
const Card = ({
  image,
  title,
  value,
  onChange,
  isEditing,
  onEditToggle,
  isMobile,
  isTablet
}) => {
  return (
    <div style={baseCardStyle(isMobile, isTablet)} className="mission-vission-cards">
      {/* Edit button at top right */}
      <div style={{
        position: "absolute",
        top: isMobile ? "10px" : "15px",
        right: isMobile ? "10px" : "15px",
      }}>
        <button
          onClick={onEditToggle}
          style={{
            backgroundColor: "#b15dc6",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: isMobile ? "30px" : "36px",
            height: isMobile ? "30px" : "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "16px",
          }}
          title={isEditing ? "Save" : "Edit"}
        >
          {isEditing ? <FaSave /> : <FaEdit />}
        </button>
      </div>

      <img src={image} alt={title} style={imageStyle(isMobile, isTablet)} />
      <h3 style={titleBaseStyle(isMobile, isTablet)}>{title}</h3>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={isMobile ? 4 : 5}
        style={textAreaStyle(isEditing, isMobile, isTablet)}
        readOnly={!isEditing}
      />
    </div>
  );
};

// Main Component
const Cateringmissionvission = () => {
  const [mission, setMission] = useState("");
  const [visionDesc, setVisionDesc] = useState("");
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null);
  const [isMissionEditing, setIsMissionEditing] = useState(false);
  const [isVisionEditing, setIsVisionEditing] = useState(false);
  const [hasData, setHasData] = useState(false);

  // Responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get vendorId from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  // Fetch existing data
  useEffect(() => {
    if (vendorId) fetchAboutUsData(vendorId);
  }, [vendorId]);

  const fetchAboutUsData = async (vendorId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/catering/api/aboutus/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;
      setAboutUsId(data?.aboutUsId || null);
      setMission(data?.mission || "");
      setVisionDesc(data?.vision || "");
      
      // Set hasData to true if we have mission or vision data
      if (data?.mission || data?.vision) {
        setHasData(true);
      }
    } catch (err) {
      console.error("Fetch Error:", err.response?.data || err.message);
    }
  };

  // Send data (both POST and PUT) like About Us format
  const sendMissionVision = async (method) => {
    if (!vendorId) return alert("Vendor ID missing!");
    if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing");

    const aboutUsData = { mission, vision: visionDesc };
    const formData = new FormData();
    formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

    const url =
      method === "POST"
        ? `https://backend.maamaas.com/catering/api/vendor/aboutus/add/${vendorId}`
        : `https://backend.maamaas.com/catering/api/vendor/aboutus/update/${aboutUsId}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
        fetchAboutUsData(vendorId);
        setIsMissionEditing(false);
        setIsVisionEditing(false);
        setHasData(true);
      } else {
        const err = await res.json();
        alert(`Failed: ${err.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  // Save individual card
  const saveIndividualCard = async (type) => {
    if (!vendorId) return alert("Vendor ID missing!");
    if (type === "mission" && !mission.trim()) return alert("Mission cannot be empty!");
    if (type === "vision" && !visionDesc.trim()) return alert("Vision cannot be empty!");

    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing");

    const aboutUsData = { mission, vision: visionDesc };
    const formData = new FormData();
    formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

    const url =
      aboutUsId
        ? `https://backend.maamaas.com/catering/api/vendor/aboutus/update/${aboutUsId}`
        : `https://backend.maamaas.com/catering/api/vendor/aboutus/add/${vendorId}`;

    try {
      const method = aboutUsId ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert(`${type === "mission" ? "Mission" : "Vision"} saved!`);
        fetchAboutUsData(vendorId);
        if (type === "mission") setIsMissionEditing(false);
        if (type === "vision") setIsVisionEditing(false);
        setHasData(true);
      } else {
        const err = await res.json();
        alert(`Failed: ${err.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <section style={containerStyle(isMobile, isTablet)}>
      {/* HEADER SECTION - Responsive layout */}
      <div style={headerContainerStyle(isMobile, isTablet)}>
        <h1 style={sectionTitleStyle(isMobile, isTablet)}>OUR COMMITMENTS</h1>
        
        {/* Only show Add button if no data exists */}
        {!hasData && (
          <button
            onClick={() => sendMissionVision("POST")}
            style={{
              ...buttonStyle(isMobile, isTablet),
              backgroundColor: "#ffffff",
              color: "#b15dc6"
            }}
          >
            Add+
          </button>
        )}
      </div>

      <div style={cardWrapperStyle(isMobile, isTablet)} className="mission-vission-card-wrapper">
        {/* Mission Card */}
        <Card
          image={misionn}
          title="Our Mission"
          value={mission}
          onChange={setMission}
          isEditing={isMissionEditing}
          onEditToggle={() => {
            if (isMissionEditing) {
              saveIndividualCard("mission");
            } else {
              setIsMissionEditing(true);
            }
          }}
          isMobile={isMobile}
          isTablet={isTablet}
        />

        {/* Vision Card */}
        <Card
          image={vision}
          title="Our Vision"
          value={visionDesc}
          onChange={setVisionDesc}
          isEditing={isVisionEditing}
          onEditToggle={() => {
            if (isVisionEditing) {
              saveIndividualCard("vision");
            } else {
              setIsVisionEditing(true);
            }
          }}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      </div>

      {/* Add CSS for better responsive behavior */}
      <style>
        {`
          @media (max-width: 480px) {
            .mission-vission-cards {
              margin: 2px 5px;
            }
          }
          
          @media (max-width: 768px) {
            .mission-vission-card-wrapper {
              padding: 0 10px;
            }
          }
          
          @media (min-width: 1025px) {
            .mission-vission-card-wrapper {
              max-width: 1200px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Cateringmissionvission;